import { CREATE_INVOICE, CREATE_INVOICE_ASSIGNMENT, CREATING_INVOICE, CREATING_INVOICE_ASSIGNMENT, GET_INVOICE_ASSIGNMENTS, GET_INVOICES, GETTING_INVOICE_ASSIGNMENTS, GETTING_INVOICES, INVOICES_ERROR, UPDATE_INVOICE, UPDATING_INVOICE } from "../types"

const initialState = {
    invoices: [],
    loadingInvoices: true,
    creatingInvoice: false,
    creatingInvoiceAssignment: false,
    createdInvoiceAssignment: null,
    loadingInvoiceAssignments: true,
    invoiceAssignments: [],
    createdInvoice: null,
    updatingInvoice: null,
    updatedInvoice: null,
    invoicesError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){

    switch(action.type){
        case GETTING_INVOICES:
            return {
                ...state,
                loadingInvoices :action.payload,
            }
        case GET_INVOICES:
            return{
                ...state,
                loadingInvoices:false,
                invoicesError:  null,
                invoices: action.payload,
            }
        case CREATING_INVOICE:
            return {
                ...state,
                creatingInvoice :action.payload,
            }
        case CREATE_INVOICE:
            return{
                ...state,
                creatingInvoice:false,
                invoicesError:  null,
                createdInvoice: action.payload,
            }
        case UPDATING_INVOICE:
            return {
                ...state,
                updatingInvoice :action.payload,
            }
        case UPDATE_INVOICE:
            return{
                ...state,
                updatingInvoice:false,
                invoicesError:  null,
                updatedInvoice: action.payload,
            }
        case CREATING_INVOICE_ASSIGNMENT:
            return{
                ...state,
                creatingInvoiceAssignment: action.payload
            }
        case CREATE_INVOICE_ASSIGNMENT:
            return{
                ...state,
                creatingInvoiceAssignment: false,
                createdInvoiceAssignment: action.payload
            }
        case GETTING_INVOICE_ASSIGNMENTS:
            return{
                ...state,
                gettingInvoiceAssignments: action.payload
            }
        case GET_INVOICE_ASSIGNMENTS:
            return{
                ...state,
                loadingInvoiceAssignments: false,
                invoiceAssignments: action.payload
            }
        case INVOICES_ERROR:
            return{
                ...state,
                loadingInvoices:false,
                creatingInvoice:false,
                updatingInvoice:null,
                creatingInvoiceAssignment: false,
                gettingInvoiceAssignments: false,
                invoicesError: action.payload 
            }
        default: return state
    }

}